function setupShopifyProduct(root = document) {
  const productScope = root.matches?.(".nw-main-product")
    ? root
    : root.querySelector(".nw-main-product");
  if (!productScope || productScope.dataset.nwProductInitialized === "true") {
    return;
  }

  productScope.dataset.nwProductInitialized = "true";
  const productForm = productScope.querySelector("[data-product-form], #NurtureWiseProductForm");
  const variantInput = productForm?.querySelector("input[name='id']");
  const addButton = productForm?.querySelector("[data-add-to-cart]");
  const price = productScope.querySelector("[data-product-price]");
  const comparePrice = productScope.querySelector("[data-compare-price]");
  const paymentButton = productForm?.querySelector(".shopify-payment-button");
  const message = productForm?.querySelector("[data-product-message]");
  const variantButtons = productScope.querySelectorAll("[data-variant-id]");
  const addLabel = addButton?.dataset.addLabel || "Add to cart";
  const addingLabel = addButton?.dataset.addingLabel || "Adding…";
  const soldOutLabel = addButton?.dataset.soldOutLabel || "Sold out";

  variantButtons.forEach(button => {
    button.addEventListener("click", () => {
      const available = button.dataset.available === "true";

      variantButtons.forEach(item => {
        const selected = item === button;
        item.classList.toggle("is-selected", selected);
        item.setAttribute("aria-checked", selected ? "true" : "false");
      });

      if (variantInput) {
        variantInput.value = button.dataset.variantId;
        variantInput.dispatchEvent(new Event("change", { bubbles: true }));
      }

      if (price && button.dataset.price) {
        price.textContent = button.dataset.price;
      }

      if (comparePrice) {
        comparePrice.textContent = button.dataset.comparePrice || "";
        comparePrice.hidden = !button.dataset.comparePrice;
      }

      if (addButton) {
        addButton.dataset.available = available ? "true" : "false";
        addButton.disabled = !available;
        addButton.textContent = available ? addLabel : soldOutLabel;
      }

      if (paymentButton) {
        paymentButton.hidden = !available;
      }

      if (message) {
        message.textContent = "";
        message.classList.remove("is-error");
      }
    });
  });

  if (!productForm || !variantInput || !addButton) {
    return;
  }

  productForm.addEventListener("submit", async event => {
    event.preventDefault();
    addButton.disabled = true;
    addButton.textContent = addingLabel;
    const rootUrl = window.Shopify?.routes?.root || "/";

    try {
      const response = await fetch(`${rootUrl}cart/add.js`, {
        method: "POST",
        headers: { "Accept": "application/json" },
        body: new FormData(productForm)
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.description || "This item could not be added.");
      }

      window.location.assign(`${rootUrl}cart`);
    } catch (error) {
      if (message) {
        message.textContent = error.message;
        message.classList.add("is-error");
      }
      const selectedVariant = Array.from(variantButtons).find(button => button.getAttribute("aria-checked") === "true");
      const selectedVariantAvailable = selectedVariant
        ? selectedVariant.dataset.available === "true"
        : addButton.dataset.available === "true";
      addButton.disabled = !selectedVariantAvailable;
      addButton.textContent = selectedVariantAvailable ? addLabel : soldOutLabel;
    }
  });
}

setupShopifyProduct();
document.addEventListener("shopify:section:load", event => setupShopifyProduct(event.target));

/*
 * v47: Shopify's dynamic checkout button changes shape per visitor.
 * Shoppers with Shop Pay get a branded "Buy with shop" wallet button; everyone
 * else gets Shopify's generic "Buy it now" fallback, which duplicates the
 * theme's own Buy it now button. Hide ours only in that fallback case, so the
 * Shop Pay express path stays available and nobody sees two identical buttons.
 */
function setupBuyNowDeduplication(root = document) {
  const scope = root.querySelector ? root : document;
  const container = scope.querySelector(".shopify-payment-button");
  const customBuyNow = document.querySelector("[data-nw-buy-now]");

  if (!container || !customBuyNow || container.dataset.nwDedupeReady === "true") {
    return;
  }

  container.dataset.nwDedupeReady = "true";

  const rendersGenericBuyNow = () => {
    if (container.querySelector("shopify-buy-it-now-button")) return true;
    if (container.querySelector(".shopify-payment-button__button--unbranded")) return true;

    const walletRendered = container.querySelector(
      "shopify-wallet-button, shop-pay-wallet-button, .shopify-payment-button__button--branded"
    );
    if (walletRendered) return false;

    const label = (container.innerText || container.textContent || "").trim().toLowerCase();
    return label.includes("buy it now");
  };

  const apply = () => {
    customBuyNow.hidden = rendersGenericBuyNow();
  };

  apply();

  const observer = new MutationObserver(apply);
  observer.observe(container, { childList: true, subtree: true, characterData: true });
  window.setTimeout(() => observer.disconnect(), 8000);
}

setupBuyNowDeduplication();
document.addEventListener("shopify:section:load", event => setupBuyNowDeduplication(event.target));

function setupAmazonBuyTracking() {
  if (window.Shopify?.designMode || document.documentElement.dataset.nwAmazonTrackingInitialized === "true") {
    return;
  }

  document.documentElement.dataset.nwAmazonTrackingInitialized = "true";
  document.addEventListener("click", event => {
    if (!(event.target instanceof Element)) {
      return;
    }

    const link = event.target.closest("a[data-amazon-buy]");
    if (!link) {
      return;
    }

    const destination = new URL(link.href, window.location.href);
    const eventDetail = {
      event: "amazon_buy_click",
      product_handle: link.dataset.amazonProductHandle || "",
      placement: link.dataset.amazonPlacement || "unknown",
      destination_host: destination.hostname
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(eventDetail);
  });
}

setupAmazonBuyTracking();
